export { body } from './BodyText.styles';
export type { BodyMixinProps } from './BodyText.styles';
export { BodyText } from './BodyText';
